export const environment = {
  production: true,
  BACKEND_API_URL: 'https://dev.studybru.ai/api',
  SUPABASE_REDIRECT_URL: 'https://dev.studybru.ai/auth/v1/callback',

  SUPABASE_URL: 'https://ryiwpejqoskfulvrdabl.supabase.co', // study-bru-prod
  SUPABASE_KEY:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5aXdwZWpxb3NrZnVsdnJkYWJsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY4NzQ4MDYsImV4cCI6MjA1MjQ1MDgwNn0.AujvZRg9AFwdSW7AsE_KFG4rL48cD_FTaSwIRNOjKyM',

  OPENAI_API_URL: 'https://api.openai.com/v1/',
  
  // Note: Now using unified completion API by default
};
